export default {
    notice: 'Note: Only active trends can be found in the Trendfinder and can be linked to elements. If links to inactive trends already exist, they can still be found.',
    header: {
        macrotrend: 'Macro-trend',
        megatrend: 'Mega-trend',
        publishingYear: 'Published',
        universes: 'Universes',
        author: 'Author',
        copy: 'Edited copy',
        tr: '#TR',
        if: '#IF',
        ip: '#IP',
        active: 'Active?',
        actions: 'Actions'
    },
    filterOptions: {
        inactive: 'inactive',
        active: 'active'
    },
    search: 'Search'
}
